import * as React from 'react'
import { IntlProvider } from 'react-intl'
import {
  Action,
  async,
  AsyncState,
  fromJSX,
  loadingAsyncState,
  stateful,
  Widget
} from 'widgets-for-react'
import { getMerchant } from '../../api/online_payment_platform'
import { MerchantResponse } from '../../types/online_payment_platform'
import { prefixUrlWithLocale } from '../../utils/url'
import {
  nextToVerify,
  stillPendingFromMerchant
} from '../online_payment_platform/onboarding'

type Props = {
  id: number
}

type State = {
  merchantResponse: AsyncState<MerchantResponse>
}

const initialState = (props: Props): State => ({
  merchantResponse: loadingAsyncState(_ => getMerchant(props.id))
})

const showMessageAfterMerchantLoaded = (
  props: Props,
  merchant: MerchantResponse
): JSX.Element => {
  const requirement = nextToVerify(merchant)
  const bankAccountMissing = merchant.bank_accounts.length === 0
  if (!requirement && !bankAccountMissing) {
    return stillPendingFromMerchant(merchant).length === 0 ? (
      <></>
    ) : (
      <div className="flash-alert">
        {I18n.t('users.opp_onboarding.not_yet_approved')}{' '}
        <a href={prefixUrlWithLocale(`/admin/${props.id}/edit#payment`)}>
          {I18n.t('users.opp_onboarding.see_status')}
        </a>
      </div>
    )
  } else if (
    requirement.type === 'bank_account.required' ||
    bankAccountMissing
  ) {
    return (
      <div className="flash-alert">
        {I18n.t('users.opp_onboarding.not_started')}{' '}
        <a href={prefixUrlWithLocale(`/admin/${props.id}/edit#payment`)}>
          {I18n.t('users.opp_onboarding.go_to_onboarding')}
        </a>
      </div>
    )
  } else {
    return (
      <div className="flash-alert">
        {I18n.t('users.opp_onboarding.not_completed')}{' '}
        <a href={prefixUrlWithLocale(`/admin/${props.id}/edit#payment`)}>
          {I18n.t('users.opp_onboarding.go_to_onboarding')}
        </a>
      </div>
    )
  }
}

const merchantLoader = (props: Props, s0: State): Widget<Action<State>> =>
  async<MerchantResponse>(merchant =>
    fromJSX(_ => showMessageAfterMerchantLoaded(props, merchant))
  )(s0.merchantResponse).map(uc => s => {
    const merchantResponse = uc(s.merchantResponse)
    return {
      ...s,
      merchantResponse
    }
  })

export class OnboardingStatusMessage extends React.Component<Props> {
  render() {
    return (
      <>
        {stateful<State>({ key: 'onboarding_status' })(s0 =>
          merchantLoader(this.props, s0).map(a => a(s0))
        )(initialState(this.props)).run(_ => {})}
      </>
    )
  }
}

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    <OnboardingStatusMessage {...props} />
  </IntlProvider>
)
